// Code review - In Progress
// Documentation - In Progress
import React, { useState, useEffect, useRef } from "react";
import { mainTable } from "../css/Common";
import "react-toastify/dist/ReactToastify.css";
import {
  GeneralMassMeetingHeaders,
  iecGDExcelExportHeader,
  iecGMMExcelExportHeader,
} from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";
import TextArea from "../ReusableComponents/TextArea";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MultiSelect from "../ReusableComponents/MultiSelect";
import GeneralMassMeetingPopup from "../popup-containers/GeneralMassMeetingPopup";
import toast from "react-hot-toast";
import {
  BindAPI,
  BindPostAPI,
  IUDAPI,
  ImageAPI,
  LanguageTranslatorAPI,
} from "../services/APIConnection";
import CheckboxOrRadioGroup from "../ReusableComponents/CheckBoxOrRadioButton";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import PopUpButtons from "../components/PopUpButtons";
import { useLocation } from "react-router-dom";
import { useUserCapability } from "../components/ConstantReducerProvider";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import { isValidMobileNumber } from "../utils/validation";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";

function GeneralMassMeeting() {
  const location = useLocation();
  useEffect(() => {
    getCurrentDate();
  }, []);
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [visibleAdd, setVisibleAdd] = React.useState(false);
  const [visibleTable, setVisibleTable] = React.useState(true);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [currentData, setCurrentData] = useState("");
  const [currentData2, setCurrentData2] = useState({});
  const [currentData3, setCurrentData3] = useState({});
  const [currentData4, setCurrentData4] = useState({});
  const [currentData5, setCurrentData5] = useState("");
  const createdBy = sessionStorage.getItem("createdBy");
  const IECType = "GMM";
  const [editMstIECId, setEditMstIECId] = useState("");
  //Data Binding
  const [bindGMMDatas, setBindGMMDatas] = useState([]);
  const [bindGMMParticipantDetailDatas, setBindGMMParticipantDetailDatas] =
    useState([]);
  const [bindGMMTopicsDatas, setBindGMMTopicsDatas] = useState([]);
  const [bindgenderRadioDD, setBindGenderRadioDD] = useState([]);
  const [bindtopics, setBindTopics] = useState([]);
  const [bindreferredtoDD, setBindreferredtoDD] = useState([]);
  const [bindreferelserviceDD, setBindreferelserviceDD] = useState([]);
  const [bindStaffName, setBindStaffName] = useState([]);
  const [bindState, setBindState] = useState([]);
  const [bindBranchProject, setBindBranchProject] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [bindFileData, setBindFileData] = useState([]);
  const [bindAgeDD, setBindAgeDD] = useState([]);
  const [getLocationDatas, setGetLocationDatas] = useState([]);
  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [getDistrictDatas, setGetDistrictDatas] = useState([]);
  const [getBlockDatas, setGetBlockDatas] = useState([]);
  const [getCityDatas, setGetCityDatas] = useState([]);
  const [bindBlock, setBindBlock] = useState([]);
  const [bindCityVillage, setBindCityVillage] = useState([]);
  const [bindDistrict, setBindDistrict] = useState([]);
  const [sdp, setSdp] = useState("");
  const [state, setState] = useState("");
  const [area, setArea] = useState("");
  const [branchProject, setBranchProject] = useState("");
  const [IECNo, setIECNo] = useState("");
  const [channel, setChannel] = useState("");
  const [staffName1, setStaffName1] = useState("");
  const [staffName2, setStaffName2] = useState("");
  const [district, setDistrict] = useState("");
  const [block, setBlock] = useState("");
  const [cityVillage, setCityVillage] = useState("");
  const [male, setMale] = useState("");
  const [female, setFemale] = useState("");
  const [other, setOther] = useState("");
  const [total, setTotal] = useState("");
  const [age1, setAge1] = useState("");
  const [age2, setAge2] = useState("");
  const [age3, setAge3] = useState("");
  const [ageTotal, setAgeTotal] = useState("");
  const [totalError, setTotalError] = useState("");
  const [description, setDescription] = useState("");
  const [topics, setTopics] = useState([]);
  const [venue, setVenue] = useState("");
  const [ageTotalError, setAgeTotalError] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [stateCode, setStateCode] = useState("");
  const [branchProjectCode, setBranchProjectCode] = useState("");
  const [sdpCode, setSdpCode] = useState("");
  const [areaCode, setAreaCode] = useState("");
  const [stateCodeDD, setStateCodeDD] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [imageDisabled, setImageDisabled] = useState(false);
  const [fileDisabled, setFileDisabled] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [date, setDate] = useState("");
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [dateError, setDateError] = useState("");
  const [venueError, setVenueError] = useState("");
  const [stateError, setStateError] = useState("");
  const [branchProjectError, setBranchProjectError] = useState("");
  const [sdpError, setSdpError] = useState("");
  const [areaError, setAreaError] = useState("");
  const [staffNameError1, setStaffNameError1] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [blockError, setBlockError] = useState("");
  const [cityVillageError, setCityVillageError] = useState("");
  const [channelError, setChannelError] = useState("");
  const [topicsError, setTopicsError] = useState("");
  const [showImageError, setShowImageError] = useState("");
  const [participantError, setParticipantError] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const issue = [
    { value: "1", label: "In-person" },
    { value: "2", label: "Virtual" },
  ];

  const API_BASE_URL = window.location.protocol === "https:" ? "https" : "http";

  const handleTopicsNameChange = (updatedOptions) => {
    setTopics(updatedOptions);
    if (updatedOptions) {
      setTopicsError(null);
    }
  };

  useEffect(() => {
    if (userProfileDatas?.length > 0) {
      initPageData(userProfileDatas[0]);
    }
  }, [userProfileDatas]);

  const initPageData = async (user) => {
    setIsLoading(true);
    try {
      await Promise.all([
        BindIECGridData(user),
        fetchDropdowns(user),
        fetchStaffNames(user),
      ]);
    } catch (error) {
      console.error("Error initializing page:", error);
    } finally {
      setIsLoading(false);
    }
  };
  // ============ IEC Grid ============
  const BindIECGridData = async (user) => {
    try {
      const Binddata = {
        iecType: IECType,
        mstOrganizationStructureId: user.MstOrganizationId,
        mstBranchId: user.MstLocationId,
        mstSdpId: user.MstSDPId || 0,
        mstUserId: user.MstUserId,
        mstRoleId: user.MstRoleId,
      };

      const response = await BindPostAPI([Binddata], "IECAPI/BindIECData");

      setBindGMMDatas(response?.data?.Table || []);
      setBindGMMParticipantDetailDatas(response?.data?.Table1 || []);
      setBindGMMTopicsDatas(response?.data?.Table2 || []);
      setBindFileData(response?.data?.Table3 || []);
    } catch (error) {
      console.error("Error fetching IEC Grid:", error);
    }
  };

  const cancel = async () => {
    setSubmitBtnDisabled(false);

    setFileDisabled(false);
    setIsLoading(false);
    setImageDisabled(false);
    setCurrentData3({});
    setEditMode(false);
    setSelectedRowIndex("");
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    Clearvalues();
    // Refresh grid data only if user profile is valid
    if (Array.isArray(userProfileDatas) && userProfileDatas[0]) {
      await BindIECGridData(userProfileDatas[0]);
    }
    setEditMode(false);
    setRowIndex("");
  };

  const showadd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    getCurrentDate();
    setChannel("1");
    Clearvalues();
    const stateLable = bindState.find(
      (ST) => ST.value === userProfileDatas[0].MstStateId,
    );
    const stateValue = {
      value: userProfileDatas[0].MstStateId,
      label: stateLable ? stateLable.label : "Select",
    };
    setState(stateValue);

    const locationLable = getLocationDatas.find(
      (L) => L.MstLocationId === userProfileDatas[0].MstLocationId,
    );
    const locationValue = {
      value: userProfileDatas[0].MstLocationId,
      label: locationLable ? locationLable.LocationName_en : "Select",
    };
    setBranchProject(locationValue);
    if (userProfileDatas[0].MstOrganizationId == 3) {
      const SDPInLable = getSDPDatas.find(
        (SD) => SD.MstSDPId === userProfileDatas[0].MstSDPId,
      );
      const SDPValue = {
        value: userProfileDatas[0].MstSDPId,
        label: SDPInLable ? SDPInLable.SDP_en : "Select",
      };
      setSdp(SDPValue);
    }
  };

  const Clearvalues = () => {
    setIECNo("");
    setParticipantError("");
    setTotalError("");
    setAgeTotalError("");
    setSdpCode("");
    setAreaCode("");
    setStateCode("");
    setBranchProjectCode("");
    setTopics("");
    setState("");
    setBranchProject("");
    setSdp("");
    setArea("");
    setVenue("");
    setDescription("");
    setChannel("1");
    setStaffName1("");
    setStaffName2("");
    setDistrict("");
    setBlock("");
    setCityVillage("");
    setShowImage("");
    setShowImageError("");
    setMale("");
    setFemale("");
    setOther("");
    setTotal("");
    setAge1("");
    setAge2("");
    setAge3("");
    setAgeTotal("");
    setSelectedFiles([]);
    setTableData([
      {
        participantNameEn: "",
        participantNameTa: "",
        participantNameHi: "",
        participantNameMr: "",
        participantNameGu: "",
        participantNameKn: "",
        participantNameMl: "",
        participantNameTe: "",
        participantNameBn: "",
        participantNameOr: "",
        age: "",
        gender: "",
        mobileNumber: "",
        referralService: "",
        referredTo: "",
        fallowUpDate: "",
      },
    ]);
    setDescription("");
    setDateError("");
    setStateError("");
    setTopicsError("");
    setBranchProjectError("");
    setSdpError("");
    setAreaError("");
    setVenueError("");
    setCityVillageError("");
    setBlockError("");
    setDistrictError("");
    setStaffNameError1("");
    setChannelError("");
  };

  // ============ Dropdowns ============
  const fetchDropdowns = async (user) => {
    const data = {
      mstOrganizationStructureId: userProfileDatas[0]?.MstOrganizationId,
      mstBranchId: userProfileDatas[0]?.MstLocationId,
      mstSdpId: userProfileDatas[0].MstSDPId ? userProfileDatas[0].MstSDPId : 0,
      mstUserId: userProfileDatas[0]?.MstUserId,
      mstRoleId: userProfileDatas[0]?.MstRoleId,
      languageCode: "en",
    };
    try {
      const [
        masterRes,
        locationRes,
        sdpRes,
        areaRes,
        districtRes,
        blockRes,
        cityRes,
      ] = await Promise.all([
        BindAPI("IECAPI/BindIECAllMasterDatas"),
        BindPostAPI([data], "LocationAPI/GetLocation"),
        BindPostAPI([data], "SDPAPI/GetSDP"),
        BindPostAPI([data], "AreaAPI/GetArea"),
        BindAPI("IECAPI/BindDistrict"),
        BindAPI("IECAPI/BindBlock"),
        BindAPI("IECAPI/BindCityVillage"),
      ]);

      const {
        Table = [],
        Table1 = [],
        Table2 = [],
        Table3 = [],
        Table4 = [],
        Table5 = [],
      } = masterRes?.data || {};

      // Batch updates for less re-rendering
      setBindTopics(
        Table.map((m) => ({ value: m.MstIECTopicsId, label: m.IECTopic_en })),
      );
      setStateCodeDD(Table1);
      setBindState(
        Table1.map((m) => ({ value: m.MstStateId, label: m.StateName_en })),
      );
      setBindAgeDD(Table2.map((m) => ({ value: m.MstAgeId, label: m.Age })));
      setBindGenderRadioDD(
        Table3.map((m) => ({ value: m.MstGenderId, label: m.Gender_en })),
      );
      setBindreferredtoDD(
        Table4.map((m) => ({
          value: m.MstReferredToId,
          label: m.ReferredTo_en,
        })),
      );
      setBindreferelserviceDD(
        Table5.map((m) => ({
          value: m.MstReferredById,
          label: m.ReferredBy_en,
        })),
      );

      setGetLocationDatas(locationRes?.data?.Table || []);
      setGetSDPDatas(sdpRes?.data?.Table || []);
      setGetAreaDatas(areaRes?.data?.Table || []);
      setGetDistrictDatas(districtRes?.data?.Table || []);
      setGetBlockDatas(blockRes?.data?.Table || []);
      setGetCityDatas(cityRes?.data?.Table || []);
    } catch (error) {
      console.error("Error fetching dropdowns:", error);
    }
  };

  // ============ Staff Names ============
  const fetchStaffNames = async (user) => {
    try {
      const staffNameRes = await BindAPI("StaffNameAPI/BindStaffName");
      const staffData =
        staffNameRes?.data?.Table?.filter(
          (item) =>
            item.MstBranchProjecctId === user.MstLocationId &&
            item.BlockedBy == null,
        ).map((item) => ({
          value: item.MstStaffNameId,
          label: item.StaffName_en,
        })) || [];

      setBindStaffName(staffData);
    } catch (error) {
      console.error("Error fetching staff names:", error);
    }
  };

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const stateSelectedValue = getDistrictDatas.find(
      (item) => item.MstStateId == state.value, // Replace with the desired MstStateId
    );
    setBindDistrict([]);
    if (stateSelectedValue) {
      const districtLabels = getDistrictDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstDistrictId: item.MstDistrictId,
          District_en: item.District_en,
        }));

      const districtSelected = districtLabels.map((LC) => ({
        value: LC.MstDistrictId, // Replace with the appropriate value
        label: LC.District_en,
      }));
      setBindDistrict(districtSelected);
    } else {
    }
  }, [state]);

  useEffect(() => {
    const BlockSelectedValue = getBlockDatas.find(
      (item) => item.MstDistrictId == district.value, // Replace with the desired MstStateId
    );
    setBindBlock([]);
    if (BlockSelectedValue) {
      const blockLabels = getBlockDatas
        .filter(
          (item) => item.MstDistrictId === BlockSelectedValue.MstDistrictId,
        )
        .map((item) => ({
          MstBlockId: item.MstBlockId,
          Block_en: item.Block_en,
        }));

      const blockSelected = blockLabels.map((SD) => ({
        value: SD.MstBlockId, // Replace with the appropriate value
        label: SD.Block_en,
      }));
      setBindBlock(blockSelected);
    } else {
    }
  }, [district]);

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const citySelectedValue = getCityDatas.find(
      (item) => item.MstBlockId == block.value, // Replace with the desired MstStateId
    );
    setBindCityVillage([]);
    if (citySelectedValue) {
      const cityLabels = getCityDatas
        .filter((item) => item.MstBlockId === citySelectedValue.MstBlockId)
        .map((item) => ({
          MstCityId: item.MstCityId,
          City_en: item.City_en,
        }));

      const citySelected = cityLabels.map((AR) => ({
        value: AR.MstCityId, // Replace with the appropriate value
        label: AR.City_en,
      }));
      setBindCityVillage(citySelected);
    } else {
    }
  }, [block]);

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const stateSelectedValue = getLocationDatas.find(
      (item) => item.MstStateId == state.value, // Replace with the desired MstStateId
    );

    if (stateSelectedValue) {
      const locationLabels = getLocationDatas
        .filter((item) => item.MstStateId === stateSelectedValue.MstStateId)
        .map((item) => ({
          MstLocationId: item.MstLocationId,
          LocationName_en: item.LocationName_en,
        }));

      const locationSelected = locationLabels.map((LC) => ({
        value: LC.MstLocationId, // Replace with the appropriate value
        label: LC.LocationName_en,
      }));
      setBindBranchProject(locationSelected);
    } else {
    }
  }, [state]);

  useEffect(() => {
    const SDPSelectedValue = getSDPDatas.find(
      (item) => item.MstLocationId == branchProject.value, // Replace with the desired MstStateId
    );

    if (SDPSelectedValue) {
      const sdpLabels = getSDPDatas
        .filter((item) => item.MstLocationId === SDPSelectedValue.MstLocationId)
        .map((item) => ({ MstSDPId: item.MstSDPId, SDP_en: item.SDP_en }));

      const sdpSelected = sdpLabels.map((SD) => ({
        value: SD.MstSDPId, // Replace with the appropriate value
        label: SD.SDP_en,
      }));
      setBindSDP(sdpSelected);
    } else {
    }
  }, [branchProject]);

  useEffect(() => {
    // Find the selected state in getLocationDatas
    const areaSelectedValue = getAreaDatas.find(
      (item) => item.MstSDPId == sdp.value, // Replace with the desired MstStateId
    );

    if (areaSelectedValue) {
      const areaLabels = getAreaDatas
        .filter((item) => item.MstSDPId === areaSelectedValue.MstSDPId)
        .map((item) => ({
          MstAreaId: item.MstAreaId,
          AreaName_en: item.AreaName_en,
        }));

      const areaSelected = areaLabels.map((AR) => ({
        value: AR.MstAreaId, // Replace with the appropriate value
        label: AR.AreaName_en,
      }));
      setBindAreaDD(areaSelected);
    } else {
    }
  }, [sdp]);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
    const day = today.getDate().toString().padStart(2, "0");
    setDate(`${year}-${month}-${day}`);
    return `${year}-${month}-${day}`;
  };

  const dropdownValuesEffect = () => {
    if (editMode && selectedRowIndex !== null) {
      dropdownstate(selectedRowIndex);
      dropdownsdp(selectedRowIndex);
      dropdownlocation(selectedRowIndex);
      dropdownArea(selectedRowIndex);
      dropdownStaff1(selectedRowIndex);
      dropdownStaff2(selectedRowIndex);
      dropdownDistrict(selectedRowIndex);
      dropdownBlock(selectedRowIndex);
      dropdownCity(selectedRowIndex);
    }
  };

  useEffect(dropdownValuesEffect, [editMode, selectedRowIndex]);

  const dropdownsdp = (rowIndex) => {
    try {
      const SDProwData = bindGMMDatas[rowIndex];
      const SDPInfo = getSDPDatas.find(
        (SD) => SD.MstSDPId === SDProwData.MstSDPId,
      );
      const ResultSDP = {
        value: SDProwData.MstSDPId,
        label: SDPInfo ? SDPInfo.SDP_en : "DefaultStateLabel",
      };
      setSdp(ResultSDP);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const dropdownlocation = (rowIndex) => {
    try {
      const locationrowData = bindGMMDatas[rowIndex];
      const LocationInfo = getLocationDatas.find(
        (L) => L.MstLocationId === locationrowData.MstLocationId,
      );
      const ResultLocation = {
        value: locationrowData.MstLocationId,
        label: LocationInfo
          ? LocationInfo.LocationName_en
          : "DefaultStateLabel",
      };
      setBranchProject(ResultLocation);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const dropdownArea = (rowIndex) => {
    try {
      const ArearowData = bindGMMDatas[rowIndex];
      const ArearowDataInfo = getAreaDatas.find(
        (AT) => AT.MstAreaId === ArearowData.MstAreaId,
      );
      const ResultArea = {
        value: ArearowData.MstAreaId,
        label: ArearowDataInfo
          ? ArearowDataInfo.AreaName_en
          : "DefaultStateLabel",
      };
      setArea(ResultArea);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };
  const dropdownstate = (rowIndex) => {
    try {
      const StaterowData = bindGMMDatas[rowIndex];
      const StateInfo = bindState.find(
        (ST) => ST.value === StaterowData.MstStateId,
      );

      const resultState = {
        value: StaterowData.MstStateId,
        label: StateInfo ? StateInfo.label : "DefaultStateLabel",
      };

      setState(resultState);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const dropdownStaff1 = (rowIndex) => {
    try {
      const staffDropdown1 = bindGMMDatas[rowIndex];

      const staffInfo1 = bindStaffName.find(
        (SD) => SD.value === staffDropdown1.StaffId1,
      );
      const ResultStaff1 = {
        value: staffDropdown1.StaffId1,
        label: staffInfo1 ? staffInfo1.label : "DefaultStateLabel",
      };
      setStaffName1(ResultStaff1);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const dropdownStaff2 = (rowIndex) => {
    try {
      const staffDropdown2 = bindGMMDatas[rowIndex];

      const staffInfo2 = bindStaffName.find(
        (SD) => SD.value === staffDropdown2.StaffId2,
      );
      const ResultStaff2 = {
        value: staffDropdown2.StaffId2,
        label: staffInfo2 ? staffInfo2.label : "DefaultStateLabel",
      };
      if (staffDropdown2.StaffId2 != null) {
        setStaffName2(ResultStaff2);
      } else {
        setStaffName2(ResultStaff2.value);
      }
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };
  const dropdownDistrict = (rowIndex) => {
    try {
      const districtData = bindGMMDatas[rowIndex];
      const districtInfo = getDistrictDatas.find(
        (L) => L.MstDistrictId === districtData.MstDistrictId,
      );
      const ResultDistrict = {
        value: districtData.MstDistrictId,
        label: districtInfo ? districtInfo.District_en : "DefaultStateLabel",
      };
      setDistrict(ResultDistrict);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const dropdownBlock = (rowIndex) => {
    try {
      const blockData = bindGMMDatas[rowIndex];
      const blockDataInfo = getBlockDatas.find(
        (AT) => AT.MstBlockId === blockData.MstBlockId,
      );
      const ResultBlock = {
        value: blockData.MstBlockId,
        label: blockDataInfo ? blockDataInfo.Block_en : "DefaultStateLabel",
      };
      setBlock(ResultBlock);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };
  const dropdownCity = (rowIndex) => {
    try {
      const cityData = bindGMMDatas[rowIndex];
      const cityInfo = getCityDatas.find(
        (ST) => ST.MstCityId === cityData.MstCityId,
      );

      const resultCity = {
        value: cityData.MstCityId,
        label: cityInfo ? cityInfo.City_en : "DefaultStateLabel",
      };
      setCityVillage(resultCity);
    } catch (error) {
      console.error("Error setting state:", error);
    }
  };

  const handleEdit = (rowIndex) => {
    setImageDisabled(true);
    setEditMode(true);
    setSelectedRowIndex(rowIndex);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    const bindMstIECId = bindGMMDatas[rowIndex].MstIECId;
    setEditMstIECId(bindGMMDatas[rowIndex].MstIECId);
    setIECNo(bindGMMDatas[rowIndex].IECNo);
    setDate(bindGMMDatas[rowIndex].OpeningDate);
    setVenue(bindGMMDatas[rowIndex].Venue_en);
    setDescription(bindGMMDatas[rowIndex].Descripition_en);
    setMale(bindGMMDatas[rowIndex].NoOfPaticipantsMale);
    setFemale(bindGMMDatas[rowIndex].NoOfPaticipantsFemale);
    setOther(bindGMMDatas[rowIndex].NoOfPaticipantsOthers);
    setTotal(bindGMMDatas[rowIndex].NoOfPaticipantsTotal);
    setAge1(bindGMMDatas[rowIndex].Age1);
    setAge2(bindGMMDatas[rowIndex].Age2);
    setAge3(bindGMMDatas[rowIndex].Age3);
    setAgeTotal(bindGMMDatas[rowIndex].AgeTotal);

    const ParticipantDetailDatas = Object.values(
      bindGMMParticipantDetailDatas,
    ).filter((item) => {
      return String(item.MstIECId) === String(bindMstIECId);
    });

    //new child table corrrected code

    setTableData([
      {
        participantNameEn: "",
        age: "",
        gender: "",
        mobileNumber: "",
        referralService: "",
        referredTo: "",
        followUpDate: "",
      },
    ]);
    if (ParticipantDetailDatas.length > 0) {
      const formattedDataArray = ParticipantDetailDatas.map((data) => {
        const formattedDateOfExpiry = data.FallowUpDate;
        const formattedDate1 = formattedDateOfExpiry
          ? formattedDateOfExpiry.split("T")[0]
          : null;
        return {
          participantNameEn: data.ParticipantName_en
            ? data.ParticipantName_en
            : "",
          age: data.MstAgeId ? data.MstAgeId : "",
          gender: data.MstGenderId ? data.MstGenderId : "",
          // mobileNumber: data.MobileNumber ? data.MobileNumber : "",
          mobileNumber:
            data.MobileNumber?.toString() == "null"
              ? ""
              : (data.MobileNumber?.toString() ?? ""),
          referralService: data.MstReferredById ? data.MstReferredById : "",
          referredTo: data.MstReferredToId ? data.MstReferredToId : "",
          fallowUpDate: formattedDate1 ? formattedDate1 : "",
        };
      });
      const nonEmptyRows = formattedDataArray.filter((row) => {
        return Object.values(row).some((value) => value !== "");
      });

      setTableData(nonEmptyRows);
      convertArrayToJSONString(nonEmptyRows);
    } else {
      // If there's no participant data, add a new row
      setTableData((prevData) => [...prevData]);
    }

    const ParticipantDetailsfilteredData = Object.values(
      bindGMMTopicsDatas,
    ).filter((item) => item.MstIECId === bindMstIECId);

    const topics = ParticipantDetailsfilteredData.map(
      (item) => item.MstTopicId,
    );
    setTopics(topics);

    const fileData = Object.values(bindFileData).filter(
      (item) => item.MstIECId === bindMstIECId,
    );

    const fileupload = fileData.map((item, index) => ({
      file: { name: `Image ${index + 1}` }, // You can customize the name if needed
      previewUrl: item.MultiFileUpload, // Assuming MultiFileUpload contains the image URL
    }));
    const imageUrlArray = [];
    for (let i = 0; i < fileupload.length; i++) {
      imageUrlArray.push(fileupload[i].previewUrl);
    }
    const imageUrlString = imageUrlArray.join(",");

    setSelectedFiles(fileupload);
    setShowImage(imageUrlString);

    const IssueRadio = bindGMMDatas[rowIndex].Channel;
    const IssueRadioString = IssueRadio ? IssueRadio.toString() : "";
    setChannel(IssueRadioString);
  };

  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    if (flag === 1 || flag === 2) {
      // validation start
      setFormSubmitted(true);

      console.log("selectedFiles", selectedFiles);

      const totalValidation = total
        ? total >= 21 // Ensure gender total is at least 21
          ? total === ageTotal
            ? "" // No error if total matches ageTotal
            : "Gender and Age total must be equal"
          : "Gender total must be at least 21"
        : "Enter No. Of Participants/Coverage Gender";

      setTotalError(totalValidation);

      const ageTotalValidation = ageTotal
        ? total >= 21 // Ensure gender total is at least 21
          ? ageTotal === total
            ? "" // No error if ageTotal matches total
            : "Age and Gender total must be equal"
          : "Gender total must be at least 21"
        : "Enter No. Of Participants/Coverage Age";

      setAgeTotalError(ageTotalValidation);

      const dateValidation = date ? "" : "Enter Date";
      setDateError(dateValidation);

      const stateValidate = state ? "" : "Select State";
      setStateError(stateValidate);

      const topicsValidation = topics.length > 0 ? "" : "Select Topics";
      setTopicsError(topicsValidation);

      const channelValidate = channel ? "" : "Choose Channel";
      setChannelError(channelValidate);

      const locationValidate = branchProject ? "" : "Select Branch/Project";
      setBranchProjectError(locationValidate);

      const sdpValidate = sdp ? "" : "Select S.D.P.";
      setSdpError(sdpValidate);

      const areaValidate = area ? "" : "Select Area";
      setAreaError(areaValidate);

      const placeValidation = venue ? "" : "Enter Venue";
      setVenueError(placeValidation);

      const staffNameValidate1 = staffName1 ? "" : "Select Staff Name1";
      setStaffNameError1(staffNameValidate1);

      const cityValidate = cityVillage ? "" : "Select City / Village";
      setCityVillageError(cityValidate);

      const districtValidate = district ? "" : "Select District";
      setDistrictError(districtValidate);

      const blockValidate = block ? "" : "Select Block";
      setBlockError(blockValidate);

      if (
        totalValidation ||
        ageTotalValidation ||
        dateValidation ||
        stateValidate ||
        locationValidate ||
        sdpValidate ||
        areaValidate ||
        placeValidation ||
        staffNameValidate1 ||
        cityValidate ||
        districtValidate ||
        blockValidate ||
        channelValidate ||
        topicsValidation
      ) {
        setIsOpen(true);
      }

      let imageValidation = "";
      let imageUrlString = showImage ? showImage.split(",") : [];
      if (!showImage) {
        imageValidation = "Please Upload an Image";
      } else {
        if (selectedFiles.length !== imageUrlString.length) {
          imageValidation = "Please Upload an Image";
        }
      }

      console.log(imageValidation);
      setShowImageError(imageValidation);
      // Wait for the conversion to complete
      const jsonString = await convertArrayToJSONString(tableData);
      let participantData = tableData;

      // Function to check if a participant object has all empty fields
      const isEmptyParticipant = (participant) => {
        return (
          !participant.participantNameEn &&
          !participant.gender &&
          !participant.age &&
          !participant.mobileNumber &&
          !participant.referralService &&
          !participant.referredTo &&
          !participant.fallowUpDate
        );
      };

      // Check if participant data is an array or an empty string
      if (!Array.isArray(participantData) && participantData !== " ") {
        console.error("Participant data is not an array");
        participantData = [];
      }

      // If participant data is an array, check for empty participants
      if (Array.isArray(participantData)) {
        const allEmpty = participantData.every(isEmptyParticipant);
        if (allEmpty) {
          participantData = " ";
        }
      }
      const maleCount = Array.isArray(participantData)
        ? participantData.filter((participant) => participant.gender == 1)
          .length
        : 0;
      const femaleCount = Array.isArray(participantData)
        ? participantData.filter((participant) => participant.gender == 2)
          .length
        : 0;
      const otherCount = Array.isArray(participantData)
        ? participantData.filter((participant) => participant.gender == 3)
          .length
        : 0;

      const age1Count = Array.isArray(participantData)
        ? participantData.filter(
          (participant) => participant.age >= 10 && participant.age <= 14,
        ).length
        : 0;
      const age2Count = Array.isArray(participantData)
        ? participantData.filter(
          (participant) => participant.age >= 15 && participant.age <= 24,
        ).length
        : 0;
      const age3Count = Array.isArray(participantData)
        ? participantData.filter((participant) => participant.age >= 25).length
        : 0;
      // Map over participant data to check for errors
      const participantErrors = Array.isArray(participantData)
        ? participantData.map((participant, index) => {
          if (!participant) {
            return `Participant at row ${index + 1} is missing.`;
          }

          // Participant Name validation
          if (!participant.participantNameEn) {
            return `Participant at row ${index + 1} is missing a Name.`;
          }

          // Age required validation
          if (!participant.age) {
            return `Participant at row ${index + 1} is missing an Age.`;
          }

          // Age must not be below 10
          const ageValue = Number(participant.age);

          if (isNaN(ageValue)) {
            return `Participant at row ${index + 1} Age must be a valid number.`;
          }

          if (ageValue < 10) {
            return `Participant at row ${index + 1} Age must be 10 years or older.`;
          }

          // Gender validation
          if (!participant.gender) {
            return `Participant at row ${index + 1} is missing a Gender.`;
          }

          // Referral Service selected but Referred To is empty
          if (participant.referralService && !participant.referredTo) {
            setSubmitBtnDisabled(false);

            return `Participant at row ${index + 1
              } has Referral Service provided but is missing Referred To field.`;
          }

          // Referred To selected but Referral Service is empty
          if (!participant.referralService && participant.referredTo) {
            setSubmitBtnDisabled(false);

            return `Participant at row ${index + 1
              } has selected Referred To but it is missing Referral Service field.`;
          }

          // Both Referral Service and Referred To selected
          // Follow-up is mandatory
          if (participant.referralService && participant.referredTo) {
            if (
              !participant.fallowUpDate ||
              participant.fallowUpDate.trim() === ""
            ) {
              setSubmitBtnDisabled(false);

              return `Participant at row ${index + 1
                } must have a Follow-up date when Referral Service and Referred To are selected.`;
            }
          }

          // Follow-up entered but both Referral Service and Referred To are empty
          if (
            participant.fallowUpDate &&
            participant.fallowUpDate.trim() !== "" &&
            !participant.referralService &&
            !participant.referredTo
          ) {
            setSubmitBtnDisabled(false);

            return `Participant at row ${index + 1
              } cannot have a Follow-up date without Referral Service and Referred To.`;
          }

          // Mobile number validation
          if (
            participant.mobileNumber &&
            participant.mobileNumber.length > 0
          ) {
            if (isValidMobileNumber(participant.mobileNumber)) {
              return null;
            } else {
              return `Participant at row ${index + 1
                } Invalid mobile number`;
            }
          }

          return null;
        })
        : [];
      // Add a single error for exceeding the male participant limit
      if (maleCount > male || femaleCount > female || otherCount > other) {
        participantErrors.push(
          "Please ensure the gender match with the number of participants/coverage*",
        );
      }

      if (age1Count > age1 || age2Count > age2 || age3Count > age3) {
        participantErrors.push(
          "Please ensure the age match with the number of participants/coverage*",
        );
      }
      // Check if there are any errors in participant data
      const filteredErrors = participantErrors.filter(
        (error) => error !== null,
      );
      // Check if there are any errors in participant data and set the error message accordingly
      if (filteredErrors.length > 0) {
        setParticipantError(filteredErrors.join("; "));
      } else {
        setParticipantError(""); // No errors found
      }

      if (
        !totalValidation &&
        !ageTotalValidation &&
        !dateValidation &&
        !stateValidate &&
        !locationValidate &&
        !sdpValidate &&
        !areaValidate &&
        !placeValidation &&
        !staffNameValidate1 &&
        !cityValidate &&
        !districtValidate &&
        !blockValidate &&
        !channelValidate &&
        !topicsValidation &&
        !imageValidation &&
        filteredErrors.length === 0
      ) {
        setIsLoading(true);
        var topicsArrayString = JSON.stringify(topics);
        topicsArrayString = topicsArrayString.slice(1, -1);
        const languageKeys = [
          "ta", // Tamil
          "hi", // Hindi
          "mr", // Marathi
          "gu", // Gujarati
          "kn", // Kannada
          "ml", // Malayalama
          "te", // Telugu
          "bn", // Bengali
          "or", // Oriya
        ];
        // const translatedTexts = []; // Create an array to store translations
        // for (let i of languageKeys) {
        //   const translateText = await LanguageTranslatorAPI(venue, i);
        //   translatedTexts.push(
        //     translateText.data.data.translations[0].translatedText
        //   );
        // }
        // const translatedRemarks = []; // Create an array to store translations
        // if (description) {
        //   for (let i of languageKeys) {
        //     const translateText = await LanguageTranslatorAPI(description, i);
        //     translatedRemarks.push(
        //       translateText.data.data.translations[0].translatedText
        //     );
        //   }
        // }
        const data = {
          MstIECId: editMstIECId ? editMstIECId : 0,
          IECNo: IECNo,
          iecType: IECType,
          topics: topicsArrayString,
          iecDate: date,
          noOfPaticipantsMale: male ? male : null,
          noOfPaticipantsFemale: female ? female : null,
          noOfPaticipantsOthers: other ? other : null,
          noOfPaticipantsTotal: total ? total : null,
          age1: age1 ? age1 : null,
          age2: age2 ? age2 : null,
          age3: age3 ? age3 : null,
          ageTotal: ageTotal ? ageTotal : null,
          channel: channel,
          mstCountryId: 1,
          mstStateId: state.value,
          mstLocationId: branchProject.value,
          mstSDPId: sdp.value,
          mstAreaId: area.value,
          staffId1: staffName1.value,
          staffId2: staffName2 ? staffName2.value : null,
          venueEn: venue,
          // venueTa: translatedTexts[0],
          // venueHi: translatedTexts[1],
          // venueMr: translatedTexts[2],
          // venueGu: translatedTexts[3],
          // venueKn: translatedTexts[4],
          // venueMl: translatedTexts[5],
          // venueTe: translatedTexts[6],
          // venueBn: translatedTexts[7],
          // venueOr: translatedTexts[8],
          venueTa: "",
          venueHi: "",
          venueMr: "",
          venueGu: "",
          venueKn: "",
          venueMl: "",
          venueTe: "",
          venueBn: "",
          venueOr: "",
          mstDistrictId: district.value,
          mstBlockId: block.value,
          mstCityId: cityVillage.value,
          iecImage: showImage,
          iecParticipantDetailsBulkUpload: jsonString, // IECParticipantDetails,
          descripition_en: description,
          // descripition_ta: translatedRemarks[0],
          // descripition_hi: translatedRemarks[1],
          // descripition_mr: translatedRemarks[2],
          // descripition_gu: translatedRemarks[3],
          // descripition_kn: translatedRemarks[4],
          // descripition_ml: translatedRemarks[5],
          // descripition_te: translatedRemarks[6],
          // descripition_bn: translatedRemarks[7],
          // descripition_or: translatedRemarks[8],
          descripition_ta: "",
          descripition_hi: "",
          descripition_mr: "",
          descripition_gu: "",
          descripition_kn: "",
          descripition_ml: "",
          descripition_te: "",
          descripition_bn: "",
          descripition_or: "",
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "IECAPI/IUDIECICAPI");
        if (flag === 1) {
          if (response?.data?.Table[0].Result === "S") {
            toast.success("General Mass Meeting data added successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to add General Mass Meeting data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            setSubmitBtnDisabled(false);
          }
        } else if (flag === 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("General Mass Meeting data updated successfully 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          } else {
            toast.error("Failed to update General Mass Meeting data 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
        setIsLoading(false);
      }
    } else {
      setIsLoading(true);
      const data = {
        MstIECId: bindGMMDatas[items].MstIECId
          ? bindGMMDatas[items].MstIECId
          : editMstIECId,
        IECType: IECType,
        createdBy: createdBy,
        flag: flag,
      };
      const response = await IUDAPI([data], "IECAPI/IUDIECICAPI");
      if (flag === 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("General Mass Meeting data deleted successfully 🗑️", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to delete General Mass Meeting data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag === 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("General Mass Meeting data blocked successfully 🚫", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to block General Mass Meeting data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      } else if (flag === 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("General Mass Meeting data unblocked successfully ✅", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        } else {
          toast.error("Failed to unblock General Mass Meeting data 👎", {
            duration: 1000,
            position: "top-center",
          });
          setTimeout(cancel, 1000);
        }
      }
    }
  };

  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };
  const handleClose = () => {
    setpopUpOpen(false);
    cancel();
  };

  const HandleGMMDetails = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }

    setCurrentData(bindGMMDatas[rowIndex]);
    const EbindMstIECId = bindGMMDatas[rowIndex].MstIECId;
    setEditMstIECId(EbindMstIECId);

    const StaterowData = bindGMMDatas[rowIndex];
    const StateInfo = bindState.find(
      (ST) => ST.value === StaterowData.MstStateId,
    );

    const resultState = {
      value: StaterowData.MstStateId,
      label: StateInfo ? StateInfo.label : "DefaultStateLabel",
    };

    const locationrowData = bindGMMDatas[rowIndex];
    const LocationInfo = getLocationDatas.find(
      (L) => L.MstLocationId === locationrowData.MstLocationId,
    );
    const ResultLocation = {
      value: locationrowData.MstLocationId,
      label: LocationInfo ? LocationInfo.LocationName_en : "DefaultStateLabel",
    };

    const SDProwData = bindGMMDatas[rowIndex];
    const SDPInfo = getSDPDatas.find(
      (SD) => SD.MstSDPId === SDProwData.MstSDPId,
    );
    const ResultSDP = {
      value: SDProwData.MstSDPId,
      label: SDPInfo ? SDPInfo.SDP_en : "DefaultStateLabel",
    };

    const ArearowData = bindGMMDatas[rowIndex];
    const ArearowDataInfo = getAreaDatas.find(
      (AT) => AT.MstAreaId === ArearowData.MstAreaId,
    );
    const ResultArea = {
      value: ArearowData.MstAreaId,
      label: ArearowDataInfo
        ? ArearowDataInfo.AreaName_en
        : "DefaultStateLabel",
    };

    const staffDropdown1 = bindGMMDatas[rowIndex];
    const staffInfo1 = bindStaffName.find(
      (SD) => SD.value === staffDropdown1.StaffId1,
    );
    const ResultStaff1 = {
      value: staffDropdown1.StaffId1,
      label: staffInfo1 ? staffInfo1.label : "DefaultStateLabel",
    };

    const staffDropdown2 = bindGMMDatas[rowIndex];
    const staffInfo2 = bindStaffName.find(
      (SD) => SD.value === staffDropdown2.StaffId2,
    );
    const ResultStaff2 = {
      value: staffDropdown2.StaffId2,
      label: staffInfo2 ? staffInfo2.label : "Select",
    };

    const districtData = bindGMMDatas[rowIndex];
    const districtInfo = getDistrictDatas.find(
      (L) => L.MstDistrictId === districtData.MstDistrictId,
    );
    const ResultDistrict = {
      value: districtData.MstDistrictId,
      label: districtInfo ? districtInfo.District_en : "DefaultStateLabel",
    };

    const blockData = bindGMMDatas[rowIndex];
    const blockDataInfo = getBlockDatas.find(
      (AT) => AT.MstBlockId === blockData.MstBlockId,
    );
    const ResultBlock = {
      value: blockData.MstBlockId,
      label: blockDataInfo ? blockDataInfo.Block_en : "DefaultStateLabel",
    };

    const cityData = bindGMMDatas[rowIndex];
    const cityInfo = getCityDatas.find(
      (ST) => ST.MstCityId === cityData.MstCityId,
    );

    const resultCity = {
      value: cityData.MstCityId,
      label: cityInfo ? cityInfo.City_en : "DefaultStateLabel",
    };

    const bindMstIECId = bindGMMDatas[rowIndex].MstIECId;

    const ParticipantDetailDatas = Object.values(
      bindGMMParticipantDetailDatas,
    ).filter((item) => {
      return String(item.MstIECId) === String(bindMstIECId);
    });

    const TopicsfilteredData = Object.values(bindGMMTopicsDatas).filter(
      (item) => item.MstIECId === bindMstIECId,
    );

    const resultTopics = TopicsfilteredData.map((item) => item.MstTopicId);

    const IssueRadio = bindGMMDatas[rowIndex].Channel;
    const IssueRadioString = IssueRadio ? IssueRadio.toString() : "";

    const fileData = Object.values(bindFileData).filter(
      (item) => item.MstIECId === bindMstIECId,
    );

    const fileupload = fileData.map((item, index) => ({
      file: { name: `Image ${index + 1}` }, // You can customize the name if needed
      previewUrl: item.MultiFileUpload, // Assuming MultiFileUpload contains the image URL
    }));

    const GMMData2 = [
      resultTopics,
      resultState,
      ResultLocation,
      ResultSDP,
      ResultArea,
      ResultStaff1,
      ResultDistrict,
      ResultBlock,
      resultCity,
      IssueRadioString,
      ResultStaff2,
    ];
    setCurrentData2(GMMData2);
    setCurrentData3(ParticipantDetailDatas);
    const drpdetailsData = [
      bindtopics,
      bindAgeDD,
      bindgenderRadioDD,
      bindreferredtoDD,
      bindreferelserviceDD,
    ];
    setCurrentData4(drpdetailsData);
    setCurrentData5(fileupload);
  };

  // Add screen table grid function
  const [tableData, setTableData] = useState([
    {
      participantNameEn: "",
      participantNameTa: "",
      participantNameHi: "",
      participantNameMr: "",
      participantNameGu: "",
      participantNameKn: "",
      participantNameMl: "",
      participantNameTe: "",
      participantNameBn: "",
      participantNameOr: "",
      age: "",
      gender: "",
      mobileNumber: "",
      referralService: "",
      referredTo: "",
      fallowUpDate: "",
    },
  ]);

  const handleInputChange = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prevData) => {
      const newData = [...prevData];
      newData[rowIndex][columnName] = value;
      return newData;
    });
  };

  const updateTableData = (value, index, property) => {
    setTableData((prevTableData) => {
      const updatedData = [...prevTableData];
      updatedData[index] = { ...updatedData[index], [property]: value };
      return updatedData;
    });
  };

  const convertArrayToJSONString = async (array) => {
    try {
      const languageKeys = [
        "ta", // Tamil
        "hi", // Hindi
        "mr", // Marathi
        "gu", // Gujarati
        "kn", // Kannada
        "ml", // Malayalam
        "te", // Telugu
        "bn", // Bengali
        "or", // Oriya
      ];
      console.log("data", languageKeys, array);

      const formattedDataArray = await Promise.all(
        array.map(async (data) => {
          console.log("data", data, 2);

          // const translateParticipantText = Array(languageKeys.length).fill("");

          // for (let i = 0; i < languageKeys.length; i++) {
          //   const translateText = await LanguageTranslatorAPI(
          //     data.participantNameEn,
          //     languageKeys[i]
          //   );
          //   translateParticipantText[i] =
          //     translateText.data.data.translations[0].translatedText;
          // }

          return {
            participantNameEn: data.participantNameEn,
            // participantNameTa: translateParticipantText[0],
            // participantNameHi: translateParticipantText[1],
            // participantNameMr: translateParticipantText[2],
            // participantNameGu: translateParticipantText[3],
            // participantNameKn: translateParticipantText[4],
            // participantNameMl: translateParticipantText[5],
            // participantNameTe: translateParticipantText[6],
            // participantNameBn: translateParticipantText[7],
            // participantNameOr: translateParticipantText[8],
            participantNameTa: "",
            participantNameHi: "",
            participantNameMr: "",
            participantNameGu: "",
            participantNameKn: "",
            participantNameMl: "",
            participantNameTe: "",
            participantNameBn: "",
            participantNameOr: "",
            age: data.age,
            gender: data.gender,
            mobileNumber: data.mobileNumber,
            referralService: data.referralService,
            referredTo: data.referredTo,
            fallowUpDate: data.fallowUpDate,
          };
        }),
      );

      const jsonString = JSON.stringify(formattedDataArray);
      return jsonString;
    } catch (error) {
      console.error("Error converting array to JSON string:", error);
      return null;
    }
  };
  // const convertArrayToJSONString = async (array) => {
  //   try {
  //     const formattedDataArray = array.map((data) => ({
  //       participantNameEn: data.participantNameEn,
  //       participantNameTa: data.participantNameEn,
  //       participantNameHi: data.participantNameEn,
  //       participantNameMr: data.participantNameEn,
  //       participantNameGu: data.participantNameEn,
  //       participantNameKn: data.participantNameEn,
  //       participantNameMl: data.participantNameEn,
  //       participantNameTe: data.participantNameEn,
  //       participantNameBn: data.participantNameEn,
  //       participantNameOr: data.participantNameEn,
  //       age: data.age,
  //       gender: data.gender,
  //       mobileNumber: data.mobileNumber,
  //       referralService: data.referralService,
  //       referredTo: data.referredTo,
  //       fallowUpDate: data.fallowUpDate,
  //     }));

  //     return JSON.stringify(formattedDataArray);
  //   } catch (error) {
  //     console.error("Error converting array to JSON string:", error);
  //     return null;
  //   }
  // };

  const handleDeleteRow = (index) => {
    setTableData((prevData) => {
      const updatedTableData = prevData.filter((_, i) => i !== index);

      // Ensure at least one row exists
      if (updatedTableData.length === 0) {
        const newRow = {
          participantNameEn: "",
          age: "",
          gender: "",
          mobileNumber: "",
          referralService: "",
          referredTo: "",
          fallowUpDate: "",
        };
        updatedTableData.push(newRow); // Add a default row if the table is empty
      }

      convertArrayToJSONString(updatedTableData); // Call convertArrayToJSONString
      return updatedTableData;
    });
  };

  const handleAddRow = () => {
    const newRow = { ...tableData[tableData.length - 1] }; // Copy the last row
    newRow.participantNameEn = ""; // Clear the values of the new row
    newRow.age = "";
    newRow.gender = "";
    newRow.mobileNumber = "";
    newRow.referralService = "";
    newRow.referredTo = "";
    newRow.fallowUpDate = "";

    setTableData((prevData) => [...prevData, newRow]); // Add the new row to the table data
  };

  const appendDataToState = (newDataString) => {
    const newDataArray = JSON.parse(newDataString);
    handleDeleteRow(0);
    const formattedDataArray = newDataArray.map((data) => {
      const formattedDateOfExpiry = data.FallowUpDate;
      const formattedDate1 = formattedDateOfExpiry
        ? formattedDateOfExpiry.split("T")[0]
        : null;
      return {
        participantNameEn: data.ParticipantName_en
          ? data.ParticipantName_en
          : "",
        age: data.MstAgeId ? data.MstAgeId : "",
        gender: data.MstGenderId ? data.MstGenderId : "",
        mobileNumber: data.MobileNumber ? data.MobileNumber : "",
        referralService: data.MstReferredById ? data.MstReferredById : "",
        referredTo: data.MstReferredToId ? data.MstReferredToId : "",
        fallowUpDate: formattedDate1 ? formattedDate1 : "",
      };
    });

    setTableData((prevData) => [...prevData, ...formattedDataArray]);
    convertArrayToJSONString(formattedDataArray);
  };

  const headerData = [
    {
      title: "Name",
      key: "participantNameEn",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Age",
      key: "age",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Gender",
      key: "gender",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Mobile No.",
      key: "mobileNumber",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Referral Service",
      key: "referralService",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Referral To",
      key: "referredTo",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Follow-up",
      key: "fallowUpDate",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
    {
      title: "Action",
      key: "Action",
      width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
    },
  ];

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showImage, setShowImage] = useState("");
  const fileInputRef = useRef(null);
  const MAX_FILE_SIZE_MB = 2;
  const ALLOWED_FORMATS = ["image/jpeg", "image/jpg", "image/png"];

  const isFileFormatAllowed = (file) => ALLOWED_FORMATS.includes(file.type);

  const isFileSizeBelowLimit = (file) =>
    file.size <= MAX_FILE_SIZE_MB * 1024 * 1024;

  const handleFileChange = (event) => {
    setImageDisabled(false);
    setFileDisabled(true);
    const files = event.target.files;

    const selectedFilesLimited = Array.from(files)
      .filter(
        (file) =>
          isFileFormatAllowed(file) &&
          isFileSizeBelowLimit(file) &&
          !selectedFiles.some(
            (selectedFile) =>
              selectedFile.file.name === file.name &&
              selectedFile.file.size === file.size,
          ), // Prevent duplicate files
      )
      .slice(0, 3);

    if (selectedFiles.length + selectedFilesLimited.length > 3) {
      setImageDisabled(true);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // Clears the file input value
      }
      toast.error("Cannot select more than 3 files", {
        duration: 3000,
        position: "top-center",
      });
      return;
    }

    setSelectedFiles((prevFiles) => [
      ...prevFiles,
      ...selectedFilesLimited.map((file) => ({
        file,
        previewUrl: URL.createObjectURL(file),
      })),
    ]);

    const unsupportedFormatFiles = Array.from(files).filter(
      (file) => !isFileFormatAllowed(file),
    );
    if (unsupportedFormatFiles.length > 0) {
      const unsupportedFilesNames = unsupportedFormatFiles
        .map((file) => file.name)
        .join(", ");
      const errorMessage = `Unsupported file format: ${unsupportedFilesNames}`;
      toast.error(errorMessage, {
        duration: 4000,
        position: "top-center",
      });
    }

    const oversizedFiles = Array.from(files).filter(
      (file) => !isFileSizeBelowLimit(file),
    );
    if (oversizedFiles.length > 0) {
      const oversizedFilesNames = oversizedFiles
        .map((file) => file.name)
        .join(", ");
      const errorMessage = `File size exceeds the limit (${MAX_FILE_SIZE_MB}MB)`;
      toast.error(errorMessage, {
        duration: 4000,
        position: "top-center",
      });
    }
  };

  // const handleUpload = async () => {
  //   setImageDisabled(true);
  //   if (selectedFiles.length === 0) {
  //     // Handle case where no files are selected
  //     toast.error("Please select files to upload", {
  //       duration: 2000,
  //       position: "top-center",
  //     });
  //     return;
  //   }

  //   const IECType = "General Mass Meeting";
  //   const formData = new FormData();

  //   // Append each selected file to the formData
  //   for (let i = 0; i < selectedFiles.length; i++) {
  //     formData.append("IECLogos", selectedFiles[i].file);
  //   }

  //   formData.append("IECType", IECType);

  //   try {
  //     const response = await ImageAPI(formData, "IECAPI/IECImageUpload");

  //     // Check if the API response contains image URLs
  //     if (Array.isArray(response.data) && response.data.length > 0) {
  //       // Update state with image URLs
  //       const allImageUrls = [
  //         ...selectedFiles.map((fileObj) => fileObj.previewUrl),
  //         ...response.data.map((fileUrl) => fileUrl),
  //       ];

  //       console.log("protocal", API_BASE_URL);
  //       const filteredImageUrls = allImageUrls.filter(
  //         (url) => !url.startsWith(`blob:${API_BASE_URL}://`)
  //       );

  //       const imageUrlString = filteredImageUrls.join(",");

  //       setShowImage(imageUrlString);
  //       toast.success("Images uploaded successfully 📷", {
  //         duration: 3000,
  //         position: "top-center",
  //       });
  //       setFileDisabled(false);
  //       setShowImageError("");
  //     } else {
  //       toast.error("Failed to upload images 👎", {
  //         duration: 2000,
  //         position: "top-center",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error uploading images:", error);
  //     toast.error("Failed to upload images 👎", {
  //       duration: 2000,
  //       position: "top-center",
  //     });
  //   }
  // };

  const handleUpload = async () => {
    setImageDisabled(true);

    if (selectedFiles.length === 0) {
      // Handle case where no files are selected
      toast.error("Please select files to upload", {
        duration: 2000,
        position: "top-center",
      });
      return;
    }

    const IECType = "General Mass Meeting";
    const formData = new FormData();

    // Append each selected file to the formData
    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append("IECLogos", selectedFiles[i].file);
    }

    formData.append("IECType", IECType);

    try {
      const response = await ImageAPI(formData, "IECAPI/IECImageUpload");

      // Check if the API response contains image URLs
      if (Array.isArray(response.data) && response.data.length > 0) {
        // Update state with image URLs
        const allImageUrls = [
          ...selectedFiles.map((fileObj) => fileObj.previewUrl),
          ...response.data.map((fileUrl) => fileUrl),
        ];

        console.log("protocal", API_BASE_URL);

        const filteredImageUrls = allImageUrls.filter(
          (url) => !url.startsWith(`blob:${API_BASE_URL}://`),
        );

        const imageUrlString = filteredImageUrls.join(",");

        setShowImage(imageUrlString);

        // ✅ Success Log
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "General Mass Meeting",
            action: "File UPLOAD",
            status: "SUCCESS",
            tableName: null,
            description: `File uploaded successfully. Total Files: ${selectedFiles.length}`,
          },
          "Log/IUDLog",
        );

        toast.success("Images uploaded successfully 📷", {
          duration: 3000,
          position: "top-center",
        });

        setFileDisabled(false);
        setShowImageError("");
      } else {
        // ❌ Failed Log
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "General Mass Meeting",
            action: "File UPLOAD",
            status: "FAILED",
            tableName: null,
            description: "Failed to upload images",
          },
          "Log/IUDLog",
        );

        toast.error("Failed to upload images 👎", {
          duration: 2000,
          position: "top-center",
        });
      }
    } catch (error) {
      console.error("Error uploading images:", error);

      // ❌ Failed Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "General Mass Meeting",
          action: "File UPLOAD",
          status: "FAILED",
          tableName: null,
          description: `Error uploading File - ${error?.message || "Unknown Error"
            }`,
        },
        "Log/IUDLog",
      );

      toast.error("Failed to upload images 👎", {
        duration: 2000,
        position: "top-center",
      });
    }
  };

  const handleImageCancel = async (index) => {
    setImageDisabled(true);
    setFileDisabled(false);
    const updatedTableData = [...selectedFiles];
    updatedTableData.splice(index, 1);
    setSelectedFiles(updatedTableData);
    const formData = new FormData();
    const imageUrlArray = [];

    for (let i = 0; i < updatedTableData.length; i++) {
      imageUrlArray.push(updatedTableData[i].previewUrl);
    }
    const imageUrlString = imageUrlArray.join(",");

    setShowImage(imageUrlString);
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clears the file input value
    }
    await IUDAPI(
      {
        mstUserId: parseInt(createdBy, 10),
        sp: "IEC - GENERAL MASS MEETING",
        action: "File DELETE",
        status: "SUCCESS",
        tableName: null,
        description: `File deleted successfully. Total Files: ${selectedFiles.length}`,
      },
      "Log/IUDLog",
    );
  };

  useEffect(() => {
    // Filter out empty values and sum the rest for gender (male, female, other)
    const totalChilds = [male, female, other]
      .filter((value) => typeof value === "number" && !isNaN(value)) // Filter out non-numeric and empty values
      .reduce((acc, value) => acc + value, 0); // Sum the values

    setTotal(totalChilds);

    if (formSubmitted) {
      GenderError();
    }

    // Compare total and ageTotal for equality after setting totals
    if (totalChilds === 0) {
      setTotalError(""); // Do not show an error for zero input
    } else if (totalChilds < 21) {
      setTotalError("Gender total must be at least 21");
    } else if (totalChilds !== ageTotal) {
      setTotalError("Gender and Age totals are not equal");
    } else {
      setTotalError(""); // Clear the error if they are equal
    }
  }, [male, female, other, ageTotal, formSubmitted]);

  useEffect(() => {
    // Filter out empty values and sum the rest for ages (age1, age2, age3)
    const totalAge = [age1, age2, age3]
      .filter((value) => typeof value === "number" && !isNaN(value)) // Filter out non-numeric and empty values
      .reduce((acc, value) => acc + value, 0); // Sum the values

    setAgeTotal(totalAge);

    if (formSubmitted) {
      AgeError();
    }

    // Compare ageTotal and total for equality after setting totals
    if (totalAge === 0) {
      setAgeTotalError(""); // Do not show an error for zero input
    } else if (totalAge < 21) {
      setAgeTotalError("Age total must be at least 21");
    } else if (total !== totalAge) {
      setAgeTotalError("Gender and Age totals are not equal");
    } else {
      setAgeTotalError(""); // Clear the error if they are equal
    }
  }, [age1, age2, age3, total, formSubmitted]);

  // Validation for Age
  const AgeError = () => {
    if (ageTotal === 0) {
      setAgeTotalError("Enter No. Of Participants/Coverage Age");
    } else {
      setAgeTotalError("");
    }
  };

  // Validation for Gender
  const GenderError = () => {
    if (total === 0) {
      setTotalError("Enter No. Of Participants/Coverage Gender");
    } else {
      setTotalError("");
    }
  };

  const GenerateId = () => {
    if (addScreenTitle) {
      if (state && branchProject && sdp && area) {
        const filteredCategory = stateCodeDD
          .filter((item) => item.MstStateId === state.value)
          .map((item) => item.StateCode);
        const filteredBranchProject = getLocationDatas
          .filter((item) => item.MstLocationId === branchProject.value)
          .map((item) => item.LocationCode);
        const filteredSdp = getSDPDatas
          .filter((item) => item.MstSDPId === sdp.value)
          .map((item) => item.SDPCode);
        const filteredArea = getAreaDatas
          .filter((item) => item.MstAreaId === area.value)
          .map((item) => item.AreaCode);

        if (
          filteredCategory.length > 0 &&
          filteredBranchProject.length > 0 &&
          filteredSdp.length > 0 &&
          filteredArea.length > 0
        ) {
          setStateCode(filteredCategory[0]);
          setBranchProjectCode(filteredBranchProject[0]);
          setSdpCode(filteredSdp[0]);
          setAreaCode(filteredArea[0]);
        }
      }
    }
  };
  useEffect(() => {
    if (addScreenTitle) {
      GenerateId();
    }
  }, [
    addScreenTitle,
    state,
    branchProject,
    sdp,
    area,
    stateCode,
    branchProjectCode,
    sdpCode,
    areaCode,
  ]);

  useEffect(() => {
    if (addScreenTitle) {
      if (stateCode && branchProjectCode && sdpCode) {
        const outputString = `${stateCode}/${branchProjectCode}/${sdpCode}/${areaCode}`;
        setIECNo(outputString);
      }
    }
  }, [addScreenTitle, stateCode, branchProjectCode, sdpCode, areaCode]);
  useEffect(() => {
    if (location.pathname == "/generalmassmeetings") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
    }
  }, [location, userProfileDatas]);

  // const handleExport = async () => {
  //
  //   try {
  //     const [profile] = userProfileDatas;

  //     const data = {
  //       iecType: IECType,
  //       mstOrganizationStructureId: profile.MstOrganizationId,
  //       mstBranchId: profile.MstLocationId,
  //       mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
  //       mstUserId: profile.MstUserId,
  //       mstRoleId: profile.MstRoleId,
  //     };
  //     const iecResponse = await BindPostAPI([data], "IECAPI/ExcelExportIECData");
  //     const rows = iecResponse?.data?.Table || [];

  //     if (rows.length === 0) {
  //       toast.error("No data available to export", {
  //         duration: 1000,
  //         position: "top-center",
  //       });
  //       return;
  //     }

  //     // ✅ PASS ONLY STRING HEADERS (same as commodities)
  //     exportData(
  //       iecGMMExcelExportHeader.map((column) => column.title),
  //       rows
  //     );
  //   } catch (error) {
  //     console.error("SDP Excel Export Error:", error);
  //     toast.error("Failed to export SDP data", {
  //       duration: 1000,
  //       position: "top-center",
  //     });
  //   }
  // };

  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");

    try {
      const [profile] = userProfileDatas;

      const data = {
        iecType: IECType,
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0,
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
      };

      const iecResponse = await BindPostAPI(
        [data],
        "IECAPI/ExcelExportIECData",
      );

      const rows = iecResponse?.data?.Table || [];

      if (rows.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "IEC - GENERAL MASS MEETING ",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: "txn_iec_general_mass_meeting",
            description: "No data available to export",
          },
          "Log/IUDLog",
        );

        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });

        return;
      } else {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "IEC - GENERAL MASS MEETING ",
            action: "EXCEL EXPORT",
            status: "SUCCESS",
            tableName: "txn_iec_general_mass_meeting",
            description: `General / Mass Meeting Excel exported successfully. Total Records: ${rows.length}`,
          },
          "Log/IUDLog",
        );
      }

      exportData(
        iecGMMExcelExportHeader.map((column) => column.title),
        rows,
      );
    } catch (error) {
      console.error("SDP Excel Export Error:", error);

      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "IEC - GENERAL MASS MEETING ",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: "txn_iec_general_mass_meeting",
          description:
            error?.message || "IEC General Mass Meeting export failed",
        },
        "Log/IUDLog",
      );

      toast.error("Failed to export SDP data", {
        duration: 1000,
        position: "top-center",
      });
    }
  };
  const exportData = (columns, rows) => {
    /* ================= TITLE ================= */
    const titleRow = [
      {
        v: "General / Mass Meeting (21+)",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];

    /* ================= HEADER ================= */
    const headerRow = columns.map((column) => ({
      v: column, // ✅ STRING ONLY
      s: {
        fill: { fgColor: { rgb: "2D2D6E" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
        alignment: { horizontal: "left" },
      },
    }));

    const spacingRow = [{ v: "" }];

    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const baseStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: baseStyle }, // S.No
        { v: rowData.MstIECId, s: baseStyle }, // S.No
        { v: rowData.Date, s: baseStyle }, // Country
        { v: rowData.StateName_en, s: baseStyle },
        { v: rowData.LocationName_en, s: baseStyle },
        { v: rowData.SDP_en, s: baseStyle },
        { v: rowData.AreaName_en, s: baseStyle },
        { v: rowData.IECNo, s: baseStyle },
        { v: rowData.IECTopic_en, s: baseStyle },
        { v: rowData.IECTopic_ta, s: baseStyle },
        { v: rowData.IECTopic_hi, s: baseStyle },
        { v: rowData.IECTopic_mr, s: baseStyle },
        { v: rowData.IECTopic_gu, s: baseStyle },
        { v: rowData.IECTopic_kn, s: baseStyle },
        { v: rowData.IECTopic_ml, s: baseStyle },
        { v: rowData.IECTopic_te, s: baseStyle },
        { v: rowData.IECTopic_bn, s: baseStyle },
        { v: rowData.IECTopic_or, s: baseStyle },
        { v: rowData.NoOfPaticipantsMale, s: baseStyle },
        { v: rowData.NoOfPaticipantsFemale, s: baseStyle },
        { v: rowData.NoOfPaticipantsOthers, s: baseStyle },
        { v: rowData.NoOfPaticipantsTotal, s: baseStyle },
        { v: rowData.Age1, s: baseStyle },
        { v: rowData.Age2, s: baseStyle },
        { v: rowData.Age3, s: baseStyle },
        { v: rowData.AgeTotal, s: baseStyle },
        { v: rowData.Channel, s: baseStyle },
        { v: rowData.StaffName_en1, s: baseStyle },
        { v: rowData.StaffName_ta1, s: baseStyle },
        { v: rowData.StaffName_hi1, s: baseStyle },
        { v: rowData.StaffName_mr1, s: baseStyle },
        { v: rowData.StaffName_gu1, s: baseStyle },
        { v: rowData.StaffName_kn1, s: baseStyle },
        { v: rowData.StaffName_ml1, s: baseStyle },
        { v: rowData.StaffName_te1, s: baseStyle },
        { v: rowData.StaffName_bn1, s: baseStyle },
        { v: rowData.StaffName_or1, s: baseStyle },
        { v: rowData.StaffName_en2, s: baseStyle },
        { v: rowData.StaffName_ta2, s: baseStyle },
        { v: rowData.StaffName_hi2, s: baseStyle },
        { v: rowData.StaffName_mr2, s: baseStyle },
        { v: rowData.StaffName_gu2, s: baseStyle },
        { v: rowData.StaffName_kn2, s: baseStyle },
        { v: rowData.StaffName_ml2, s: baseStyle },
        { v: rowData.StaffName_te2, s: baseStyle },
        { v: rowData.StaffName_bn2, s: baseStyle },
        { v: rowData.StaffName_or2, s: baseStyle },
        { v: rowData.Venue_en, s: baseStyle },
        { v: rowData.Venue_ta, s: baseStyle },
        { v: rowData.Venue_hi, s: baseStyle },
        { v: rowData.Venue_mr, s: baseStyle },
        { v: rowData.Venue_gu, s: baseStyle },
        { v: rowData.Venue_kn, s: baseStyle },
        { v: rowData.Venue_ml, s: baseStyle },
        { v: rowData.Venue_te, s: baseStyle },
        { v: rowData.Venue_bn, s: baseStyle },
        { v: rowData.Venue_or, s: baseStyle },
        { v: rowData.District_en, s: baseStyle },
        { v: rowData.District_ta, s: baseStyle },
        { v: rowData.District_hi, s: baseStyle },
        { v: rowData.District_mr, s: baseStyle },
        { v: rowData.District_gu, s: baseStyle },
        { v: rowData.District_kn, s: baseStyle },
        { v: rowData.District_ml, s: baseStyle },
        { v: rowData.District_te, s: baseStyle },
        { v: rowData.District_bn, s: baseStyle },
        { v: rowData.District_or, s: baseStyle },
        { v: rowData.Block_en, s: baseStyle },
        { v: rowData.Block_ta, s: baseStyle },
        { v: rowData.Block_hi, s: baseStyle },
        { v: rowData.Block_mr, s: baseStyle },
        { v: rowData.Block_gu, s: baseStyle },
        { v: rowData.Block_kn, s: baseStyle },
        { v: rowData.Block_ml, s: baseStyle },
        { v: rowData.Block_te, s: baseStyle },
        { v: rowData.Block_bn, s: baseStyle },
        { v: rowData.Block_or, s: baseStyle },
        { v: rowData.City_en, s: baseStyle },
        { v: rowData.City_ta, s: baseStyle },
        { v: rowData.City_hi, s: baseStyle },
        { v: rowData.City_mr, s: baseStyle },
        { v: rowData.City_gu, s: baseStyle },
        { v: rowData.City_kn, s: baseStyle },
        { v: rowData.City_ml, s: baseStyle },
        { v: rowData.City_te, s: baseStyle },
        { v: rowData.City_bn, s: baseStyle },
        { v: rowData.City_or, s: baseStyle },
        { v: rowData.MultiFileUpload, s: baseStyle },

        { v: rowData.ParticipantName_en, s: baseStyle },
        { v: rowData.ParticipantName_ta, s: baseStyle },
        { v: rowData.ParticipantName_hi, s: baseStyle },
        { v: rowData.ParticipantName_mr, s: baseStyle },
        { v: rowData.ParticipantName_gu, s: baseStyle },
        { v: rowData.ParticipantName_kn, s: baseStyle },
        { v: rowData.ParticipantName_ml, s: baseStyle },
        { v: rowData.ParticipantName_te, s: baseStyle },
        { v: rowData.ParticipantName_bn, s: baseStyle },
        { v: rowData.ParticipantName_or, s: baseStyle },
        { v: rowData.MstAgeId, s: baseStyle },
        { v: rowData.Gender_en, s: baseStyle },
        { v: rowData.Gender_ta, s: baseStyle },
        { v: rowData.Gender_hi, s: baseStyle },
        { v: rowData.Gender_mr, s: baseStyle },
        { v: rowData.Gender_gu, s: baseStyle },
        { v: rowData.Gender_kn, s: baseStyle },
        { v: rowData.Gender_ml, s: baseStyle },
        { v: rowData.Gender_te, s: baseStyle },
        { v: rowData.Gender_bn, s: baseStyle },
        { v: rowData.Gender_or, s: baseStyle },
        { v: rowData.MobileNumber, s: baseStyle },
        { v: rowData.ReferredBy_en, s: baseStyle },
        { v: rowData.ReferredBy_ta, s: baseStyle },
        { v: rowData.ReferredBy_hi, s: baseStyle },
        { v: rowData.ReferredBy_mr, s: baseStyle },
        { v: rowData.ReferredBy_gu, s: baseStyle },
        { v: rowData.ReferredBy_kn, s: baseStyle },
        { v: rowData.ReferredBy_ml, s: baseStyle },
        { v: rowData.ReferredBy_te, s: baseStyle },
        { v: rowData.ReferredBy_bn, s: baseStyle },
        { v: rowData.ReferredBy_or, s: baseStyle },
        { v: rowData.ReferredTo_en, s: baseStyle },
        { v: rowData.ReferredTo_ta, s: baseStyle },
        { v: rowData.ReferredTo_hi, s: baseStyle },
        { v: rowData.ReferredTo_mr, s: baseStyle },
        { v: rowData.ReferredTo_gu, s: baseStyle },
        { v: rowData.ReferredTo_kn, s: baseStyle },
        { v: rowData.ReferredTo_ml, s: baseStyle },
        { v: rowData.ReferredTo_te, s: baseStyle },
        { v: rowData.ReferredTo_bn, s: baseStyle },
        { v: rowData.ReferredTo_or, s: baseStyle },
        { v: rowData.FallowUpDate, s: baseStyle },
        { v: rowData.Descripition_en, s: baseStyle },
        { v: rowData.Descripition_ta, s: baseStyle },
        { v: rowData.Descripition_hi, s: baseStyle },
        { v: rowData.Descripition_mr, s: baseStyle },
        { v: rowData.Descripition_gu, s: baseStyle },
        { v: rowData.Descripition_kn, s: baseStyle },
        { v: rowData.Descripition_ml, s: baseStyle },
        { v: rowData.Descripition_te, s: baseStyle },
        { v: rowData.Descripition_bn, s: baseStyle },
        { v: rowData.Descripition_or, s: baseStyle },
        { v: rowData.FullName_en, s: baseStyle },
      ];
    });

    /* ================= SHEET DATA ================= */
    const wsData = [titleRow, spacingRow, headerRow, ...dataRows];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = [
      { width: 5 }, // S.No
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 50 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];

    /* ================= ROW HEIGHTS ================= */
    ws["!rows"] = [
      { hpt: 30 },
      { hpt: 15 },
      { hpt: 18 },
      ...Array(rows.length).fill({ hpt: 15 }),
    ];

    /* ================= BORDERS ================= */
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!worksheet[cellRef]) continue;

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    /* ================= EXPORT ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SDP Master");
    XLSX.writeFile(wb, "General / Mass Meeting (21+).xlsx");

    toast.success("Excel exported successfully 👍", {
      duration: 1000,
      position: "top-center",
    });
  };

  return (
    <MainLayout pageName="3">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="General / Mass Meeting (21+)"
          header={GeneralMassMeetingHeaders}
          records={bindGMMDatas}
          handleEdit={handleEdit}
          handleAction={HandleGMMDetails}
          showAdd={showadd}
          blockView={true}
          handleExportBtn={true}
          handleExport={handleExport}
        />
      )}
      {visibleAdd && (
        <div class="w-full ">
          <AddScreenTitle
            addScreenTitle={addScreenTitle}
            updateScreenTitle={updateScreenTitle}
            title="General / Mass Meeting (21+)"
          />
          <div className={mainTable.addShadowScreen}>
            <div className={mainTable.mainContentScreen}>
              <form class="space-y-6" action="#">
                <div className={mainTable.grid3}>
                  <div>
                    <InputText
                      inputType="date"
                      classStar="text-red-500"
                      title=" Date"
                      name="date"
                      tabIndex="0"
                      content={date}
                      controlFunc={(e) => setDate(e.target.value)}
                      controlFuncBlur={(e) => {
                        setDate(e.target.value);
                        setDateError(date ? "" : "Please Select Date");
                      }}
                      max={new Date().toISOString().split("T")[0]}
                    />
                    {dateError && <span class="text-red-500">{dateError}</span>}
                  </div>
                  <div>
                    <AutoDropDown
                      title="State"
                      classStar="text-red-500"
                      options={bindState}
                      disabled={true}
                      placeholder="Select"
                      name="state"
                      selectedOption={state}
                      Class="custom-class"
                      tabIndex="0"
                      controlFunc={(value) => {
                        setState(value);
                        setStateError(value ? "" : "Select State");
                        setBranchProject("");
                        setSdp("");
                        setArea("");
                        setDistrict("");
                        setBlock("");
                        setCityVillage("");
                      }}
                      controlFuncBlur={() => {
                        setStateError(state ? "" : "Select State");
                      }}
                    />
                    {stateError && (
                      <span className="text-red-500">{stateError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Branch/Project"
                      classStar="text-red-500"
                      options={bindBranchProject}
                      disabled={true}
                      placeholder="Select"
                      name="branchProject"
                      selectedOption={branchProject}
                      Class="custom-class"
                      tabIndex="0"
                      controlFunc={(value) => {
                        setBranchProject(value);
                        setBranchProjectError(
                          value ? "" : "Select Branch/Project",
                        );
                        setSdp("");
                        setArea("");
                      }}
                      controlFuncBlur={() => {
                        setBranchProjectError(
                          branchProject ? "" : "Select Branch/Project",
                        );
                      }}
                    />
                    {branchProjectError && (
                      <span className="text-red-500">{branchProjectError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="S.D.P."
                      classStar="text-red-500"
                      options={bindSDP}
                      disabled={
                        editMode || userProfileDatas[0].MstOrganizationId == 3
                      }
                      placeholder="Select"
                      name="sdp"
                      selectedOption={sdp}
                      Class="custom-class"
                      tabIndex="0"
                      controlFunc={(value) => {
                        setSdp(value);
                        setSdpError(value ? "" : "Select S.D.P.");
                        setArea("");
                      }}
                      controlFuncBlur={() => {
                        setSdpError(sdp ? "" : "Select S.D.P.");
                      }}
                    />
                    {sdpError && (
                      <span className="text-red-500">{sdpError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Area"
                      classStar="text-red-500"
                      options={bindArea}
                      disabled={editMode}
                      placeholder="Select"
                      name="area"
                      selectedOption={area}
                      Class="custom-class"
                      tabIndex="0"
                      controlFunc={(value) => {
                        setArea(value);
                        setAreaError(value ? "" : "Select Area");
                      }}
                      controlFuncBlur={() => {
                        setAreaError(area ? "" : "Select Area");
                      }}
                    />
                    {areaError && (
                      <span className="text-red-500">{areaError}</span>
                    )}
                  </div>
                  <div>
                    <InputText
                      inputType="text"
                      classStar="text-red-500"
                      title="General / Mass Meetings No. "
                      placeholder="MH/MUM/DHI/MAN/GMM/2023/0001"
                      name="generalMassMeetingsNo"
                      maxLength={30}
                      disabled={true}
                      tabIndex="0"
                      content={IECNo}
                      controlFunc={(e) => setIECNo(e.target.value)}
                      controlFuncBlur={(e) => {
                        setIECNo(e.target.value);
                      }}
                    />
                  </div>
                  <div>
                    <MultiSelect
                      classStar="text-red-500"
                      label="Topics"
                      filteredOptions={bindtopics}
                      classFilterLabel="p-1 flex gap-1"
                      class="custom-class"
                      tabIndex="0"
                      placeholder={
                        topics?.length > 0 ? "More Selected" : "Select..."
                      }
                      name="topicsNames"
                      selectedOptions={topics}
                      classDiv="relative w-full inline-block"
                      onChange={handleTopicsNameChange}
                      controlFuncBlur={() => {
                        setTopicsError(
                          topics?.length == 0 ? "Select Topics" : null,
                        );
                      }}
                    />
                    {topicsError && (
                      <span class="text-red-500">{topicsError}</span>
                    )}
                  </div>
                </div>
                <div class={mainTable.grid2}>
                  <div className="col-span-2">
                    <label htmlFor="client_name" class={mainTable.label}>
                      No. of Participants/Coverage
                      <span className="text-red-500">*</span>
                    </label>
                    <hr class={mainTable.horizontalLine}></hr>
                    <div class="flex gap-6">
                      <div class="flex flex-col">
                        <label class={mainTable.label}>Gender</label>
                        <div className={mainTable.inputGenderClient}>
                          <InputText
                            inputType={"text"}
                            ClassDiv="grid gap-2 grid-cols-2"
                            ClassLabel={mainTable.labelBaseline}
                            Class={mainTable.smallInput}
                            title={"Male"}
                            name={"male"}
                            tabIndex="0"
                            maxLength={5}
                            content={male}
                            controlFunc={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseInt(value, 10);
                              setMale(isNaN(parsedValue) ? "" : parsedValue);
                            }}
                          />
                          <InputText
                            inputType={"text"}
                            ClassDiv="grid gap-2 grid-cols-2"
                            ClassLabel={mainTable.labelBaseline}
                            Class={mainTable.smallInput}
                            title={"Female"}
                            tabIndex="0"
                            maxLength={5}
                            name={"femaleChild"}
                            content={female}
                            controlFunc={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseInt(value, 10);
                              setFemale(isNaN(parsedValue) ? "" : parsedValue);
                            }}
                          />
                          <InputText
                            inputType={"text"}
                            tabIndex="0"
                            ClassDiv="grid gap-2 grid-cols-2"
                            ClassLabel={mainTable.labelBaseline}
                            Class={mainTable.smallInput}
                            title={"Other"}
                            maxLength={5}
                            name={"otherChild"}
                            content={other}
                            controlFunc={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseInt(value, 10);
                              setOther(isNaN(parsedValue) ? "" : parsedValue);
                            }}
                          />
                          <InputText
                            inputType={"text"}
                            tabIndex="0"
                            ClassDiv="grid gap-2 grid-cols-2"
                            ClassLabel={mainTable.labelBaseline}
                            Class={mainTable.smallInput}
                            title={"total"}
                            disabled={true}
                            maxLength={5}
                            name={"totalChild"}
                            content={total}
                            controlFunc={() => { }}
                            controlFuncBlur={(e) => {
                              setTotal(e.target.value);
                            }}
                          />
                        </div>
                        {totalError && (
                          <span class="text-red-500">{totalError}</span>
                        )}
                      </div>
                      <div class="flex flex-col">
                        <label class={mainTable.label}>Age</label>
                        <div className={mainTable.inputGenderClient}>
                          <InputText
                            inputType={"text"}
                            tabIndex="0"
                            ClassDiv="grid gap-2 grid-cols-2"
                            ClassLabel={mainTable.labelBaseline}
                            Class={mainTable.smallInput}
                            title={"10-14"}
                            name={"age1"}
                            maxLength={5}
                            content={age1}
                            controlFunc={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseInt(value, 10);
                              setAge1(isNaN(parsedValue) ? "" : parsedValue);
                            }}
                          />
                          <InputText
                            inputType={"text"}
                            ClassDiv="grid gap-2 grid-cols-2"
                            ClassLabel={mainTable.labelBaseline}
                            Class={mainTable.smallInput}
                            title={"15-24"}
                            maxLength={5}
                            tabIndex="0"
                            name={"age2"}
                            content={age2}
                            controlFunc={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseInt(value, 10);
                              setAge2(isNaN(parsedValue) ? "" : parsedValue);
                            }}
                          />
                          <InputText
                            inputType={"text"}
                            ClassDiv="grid gap-2 grid-cols-2"
                            ClassLabel={mainTable.labelBaseline}
                            tabIndex="0"
                            Class={mainTable.smallInput}
                            title={"25+"}
                            maxLength={5}
                            name={"age3"}
                            content={age3}
                            controlFunc={(e) => {
                              const value = e.target.value;
                              const parsedValue = parseInt(value, 10);
                              setAge3(isNaN(parsedValue) ? "" : parsedValue);
                            }}
                          />
                          <InputText
                            inputType={"text"}
                            tabIndex="0"
                            ClassDiv="grid gap-2 grid-cols-2"
                            ClassLabel={mainTable.labelBaseline}
                            Class={mainTable.smallInput}
                            title={"Total"}
                            maxLength={5}
                            name={"ageTotal"}
                            disabled={true}
                            content={ageTotal}
                            controlFunc={() => { }}
                            controlFuncBlur={(e) => {
                              setAgeTotal(e.target.value);
                            }}
                          />
                        </div>
                        {ageTotalError && (
                          <span class="text-red-500">{ageTotalError}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div class={mainTable.grid3}>
                  <div>
                    <CheckboxOrRadioGroup
                      classStar="text-red-500"
                      title="Channel"
                      type={"radio"}
                      setName="channel"
                      selectedOptions={channel}
                      options={issue}
                      disabled={false}
                      tabIndex="0"
                      controlFunc={(e) => {
                        setChannel(e.target.value);
                        setChannelError(e.target.value ? "" : "Choose Chennel");
                      }}
                      controlFuncBlur={(e) => {
                        setChannel(e.target.value);
                        setChannelError(channel ? "" : "Choose Chennel");
                      }}
                    />
                    {channelError && (
                      <span class="text-red-500">{channelError}</span>
                    )}
                  </div>

                  <div>
                    <AutoDropDown
                      title="Staff Name1"
                      classStar="text-red-500"
                      options={bindStaffName}
                      placeholder="Select"
                      name="staffName1"
                      Class="custom-class"
                      tabIndex="0"
                      selectedOption={staffName1}
                      controlFunc={(value) => {
                        setStaffName1(value);
                        setStaffNameError1(value ? "" : "Select Staff Name1");
                      }}
                      controlFuncBlur={() => {
                        setStaffNameError1(
                          staffName1 ? "" : "Select Staff Name1",
                        );
                      }}
                    />
                    {staffNameError1 && (
                      <span className="text-red-500">{staffNameError1}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Staff Name2"
                      options={bindStaffName}
                      placeholder="Select"
                      name="staffName2"
                      Class="custom-class"
                      tabIndex="0"
                      selectedOption={staffName2}
                      controlFunc={(value) => {
                        setStaffName2(value);
                      }}
                    />
                  </div>
                  <div>
                    <InputText
                      title="Venue "
                      type="text"
                      name="venue"
                      maxLength={100}
                      placeholder="Venue"
                      classStar="text-red-500"
                      tabIndex="0"
                      content={venue}
                      controlFunc={(e) => {
                        const value = e.target.value;
                        setVenue(value);
                        setVenueError(
                          value.trim().length > 0 ? "" : "Enter Venue",
                        );
                      }}
                      controlFuncBlur={(e) => {
                        const trimmedValue = e.target.value.trim();
                        setVenue(trimmedValue);
                        setVenueError(
                          trimmedValue.length > 0 ? "" : "Enter Venue",
                        );
                      }}
                    />
                    {venueError && (
                      <span class="text-red-500">{venueError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="District"
                      classStar="text-red-500"
                      options={bindDistrict}
                      placeholder="Select"
                      name="district"
                      Class="custom-class"
                      tabIndex="0"
                      selectedOption={district}
                      controlFunc={(value) => {
                        setDistrict(value);
                        setDistrictError(value ? "" : "Select District");
                        setBlock("");
                        setCityVillage("");
                      }}
                      controlFuncBlur={() => {
                        setDistrictError(district ? "" : "Select District");
                      }}
                    />
                    {districtError && (
                      <span className="text-red-500">{districtError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="Block"
                      classStar="text-red-500"
                      options={bindBlock}
                      placeholder="Select"
                      name="block"
                      Class="custom-class"
                      tabIndex="0"
                      selectedOption={block}
                      controlFunc={(value) => {
                        setBlock(value);
                        setBlockError(value ? "" : "Select Block");
                        setCityVillage("");
                      }}
                      controlFuncBlur={() => {
                        setBlockError(block ? "" : "Select Block");
                      }}
                    />
                    {blockError && (
                      <span className="text-red-500">{blockError}</span>
                    )}
                  </div>
                  <div>
                    <AutoDropDown
                      title="City / Village"
                      classStar="text-red-500"
                      options={bindCityVillage}
                      placeholder="Select"
                      name="cityVillage"
                      Class="custom-class"
                      tabIndex="0"
                      selectedOption={cityVillage}
                      controlFunc={(value) => {
                        setCityVillage(value);
                        setCityVillageError(
                          value ? "" : "Select City / Village",
                        );
                      }}
                      controlFuncBlur={() => {
                        setCityVillageError(
                          cityVillage ? "" : "Select City / Village",
                        );
                      }}
                    />
                    {cityVillageError && (
                      <span className="text-red-500">{cityVillageError}</span>
                    )}
                  </div>
                </div>
                <div className={mainTable.grid3}>
                  {/* <div>
                    <div className="mb-2">
                      <label className="block mb-2 text-sm capitalize font-medium text-neutral-700">
                        File Upload<span className="text-red-500">*</span>
                      </label>
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      className={mainTable.input}
                      onChange={handleFileChange}
                      disabled={fileDisabled ? true : false}
                      accept=".jpg, .jpeg, .png"
                    />
                    {showImageError && (
                      <span className="text-red-500">{showImageError}</span>
                    )}
                    {selectedFiles.length > 3 && (
                      <div className="text-red-500">
                        Reached Maximum No. of Uploads
                      </div>
                    )}
                  </div> */}
                  <div>
                    <div className="mb-2">
                      <label className="block mb-2 text-sm capitalize font-medium text-neutral-700">
                        File Upload
                      </label>
                    </div>

                    <input
                      type="file"
                      ref={fileInputRef}
                      className={mainTable.input}
                      tabIndex="0"
                      onChange={handleFileChange}
                      disabled={fileDisabled}
                      accept=".jpg,.jpeg,.png"
                    />

                    {/* Helper message */}
                    <div className="mt-1 text-sm text-gray-500">
                      Image size limit: 2MB. Accepted Image types: jpg, png,
                      jpeg.
                    </div>

                    {/* Error message */}
                    {showImageError && (
                      <span className="text-red-500 block mt-1">
                        {showImageError}
                      </span>
                    )}

                    {/* Maximum upload message */}
                    {selectedFiles.length > 3 && (
                      <div className="text-red-500 mt-1">
                        Reached Maximum No. of Uploads
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {selectedFiles.length > 0 && (
                    <div class="flex gap-8">
                      {selectedFiles.map((item, index) => (
                        <div key={index} className="image-container">
                          <span
                            class="float-right cursor-pointer"
                            onClick={() => handleImageCancel(index)}
                          >
                            X
                          </span>
                          <img
                            src={item.previewUrl}
                            alt={`preview-${index}`}
                            class={`w-28 h-28 m-3`}
                          />
                          <span class={mainTable.label}>{item.file?.name}</span>
                          {index === selectedFiles.length - 1 && (
                            <input
                              type="button"
                              className={
                                imageDisabled
                                  ? mainTable.disabledSubmitButton
                                  : mainTable.submitButton
                              }
                              onClick={handleUpload}
                              disabled={imageDisabled ? true : false}
                              value="Upload"
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div class={mainTable.labelBold}>List of Referrals</div>
                <div className="hidden md:block overflow-x-auto">
                  <div className="table-container w-screen md:w-max xl:w-full max-h-96">
                    <table className="w-full border border-gray-300 ">
                      <thead>
                        <tr>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                            Name
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                            Age
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                            Gender
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                            Mobile No.
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                            Referral Service
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                            Referred To
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2 w-32">
                            Follow-up
                          </th>
                          <th className="border text-white bg-[#2d2d6e] border-gray-300 ">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData.map((row, index) => (
                          <tr key={index}>
                            <td className="border border-gray-300 p-2">
                              <input
                                type="text"
                                className={mainTable.input}
                                value={row.participantNameEn}
                                maxLength={100}
                                placeholder="Name"
                                tabIndex="0"
                                onChange={(e) => {
                                  const InputText = e.target.value;
                                  if (
                                    InputText.length === 0 ||
                                    /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(
                                      InputText.trim(),
                                    )
                                  ) {
                                    handleInputChange(
                                      InputText,
                                      index,
                                      "participantNameEn",
                                    );
                                    updateTableData(
                                      InputText,
                                      index,
                                      "participantNameEn",
                                    );
                                  }
                                }}
                              />
                            </td>

                            <td className="border border-gray-300 p-2 w-28">
                              <input
                                type="text"
                                className={mainTable.input}
                                value={row.age}
                                maxLength={2}
                                tabIndex="0"
                                placeholder="Age"
                                onChange={(e) => {
                                  const InputText = e.target.value;
                                  if (/^\d{0,2}$/.test(InputText)) {
                                    handleInputChange(InputText, index, "age");
                                    updateTableData(InputText, index, "age");
                                  }
                                }}
                              />
                            </td>
                            <td className="border border-gray-300 p-2">
                              <DropDown
                                options={bindgenderRadioDD}
                                placeholder="Select"
                                name="gender"
                                selectedOption={row.gender}
                                tabIndex="0"
                                controlFunc={(e) =>
                                  updateTableData(
                                    e.target.value,
                                    index,
                                    "gender",
                                  )
                                }
                              />
                            </td>

                            <td className="border border-gray-300 p-2">
                              <input
                                type="text"
                                className={mainTable.input}
                                value={row.mobileNumber}
                                maxLength={11}
                                tabIndex="0"
                                minLength={10}
                                onChange={(e) => {
                                  const InputText = e.target.value;
                                  if (/^[0-9]*$/.test(InputText)) {
                                    handleInputChange(
                                      InputText,
                                      index,
                                      "mobileNumber",
                                    );
                                    updateTableData(
                                      InputText,
                                      index,
                                      "mobileNumber",
                                    );

                                    if (isValidMobileNumber(InputText)) {
                                      setParticipantError("");
                                    } else {
                                      setParticipantError(
                                        "Invalid mobile number",
                                      );
                                    }
                                  }
                                  if (e.target.value == "") {
                                    setParticipantError("");
                                  }
                                }}
                              />
                            </td>

                            <td className="border border-gray-300 p-2">
                              <DropDown
                                options={bindreferelserviceDD}
                                placeholder="Select"
                                name="referralService"
                                tabIndex="0"
                                selectedOption={row.referralService}
                                controlFunc={(e) =>
                                  updateTableData(
                                    e.target.value,
                                    index,
                                    "referralService",
                                  )
                                }
                              />
                            </td>

                            <td className="border border-gray-300 p-2">
                              <DropDown
                                options={bindreferredtoDD}
                                placeholder="Select"
                                name="referredTo"
                                selectedOption={row.referredTo}
                                tabIndex="0"
                                controlFunc={(e) =>
                                  updateTableData(
                                    e.target.value,
                                    index,
                                    "referredTo",
                                  )
                                }
                              />
                            </td>

                            <td className="border border-gray-300 p-2">
                              <InputText
                                inputType="date"
                                tabIndex="0"
                                content={row.fallowUpDate}
                                controlFunc={(e) => {
                                  handleInputChange(
                                    e.target,
                                    index,
                                    "fallowUpDate",
                                  );
                                  updateTableData(
                                    e.target.value,
                                    index,
                                    "fallowUpDate",
                                  );
                                }}
                                min={new Date().toISOString().split("T")[0]}
                              />
                            </td>

                            <td className="border border-gray-300 w-16">
                              <div className="flex gap-4 align-baseline items-center justify-center">
                                <svg
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  class="w-6 h-6 text-black cursor-pointer"
                                  onClick={() => handleDeleteRow(index)}
                                >
                                  <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                                </svg>
                                <svg
                                  viewBox="0 0 1024 1024"
                                  fill="currentColor"
                                  onClick={handleAddRow}
                                  class="w-6 h-6 text-black cursor-pointer"
                                >
                                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                                </svg>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="hidden md:block">
                  {participantError && (
                    <div className="text-red-500">{participantError}</div>
                  )}
                </div>
                <div className={mainTable.childTableMobile} role="table">
                  <div className="w-full md:overflow-y-auto lg:h-96 h-full">
                    {tableData.length > 0 &&
                      tableData.map((row, index) => (
                        <div scope="col" class={mainTable.mobileTable}>
                          {headerData.map((keyData) => (
                            <div
                              scope="cell"
                              class={mainTable.tableData}
                              role="cell"
                            >
                              {keyData.key === "Action" ? (
                                <div class={mainTable.tableData}>
                                  <div className="md:block hidden">
                                    <button
                                      id="dropdownMenuIconButton"
                                      data-dropdown-toggle="dropdownDots"
                                      class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none  focus:ring-gray-50 "
                                      type="button"
                                    >
                                      <svg
                                        class="w-6 h-6"
                                        aria-hidden="true"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
                                      </svg>
                                    </button>
                                  </div>
                                  <div className="md:hidden flex justify-center">
                                    <input
                                      type="button"
                                      className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                      onClick={handleAddRow}
                                      value="Add"
                                    />
                                    <input
                                      type="button"
                                      className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                                      onClick={() => handleDeleteRow(index)}
                                      value="Delete"
                                    />
                                  </div>
                                </div>
                              ) : keyData.key === "participantNameEn" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full font-bold">
                                    {keyData.title}
                                  </div>
                                  <input
                                    type="text"
                                    className={mainTable.input}
                                    value={row.participantNameEn}
                                    maxLength={100}
                                    placeholder="Name"
                                    onChange={(e) => {
                                      const InputText = e.target.value;
                                      if (
                                        InputText.length === 0 ||
                                        /^[A-Za-z]+(?:\s[A-Za-z]+)*$/.test(
                                          InputText.trim(),
                                        )
                                      ) {
                                        handleInputChange(
                                          InputText,
                                          index,
                                          "participantNameEn",
                                        );
                                        updateTableData(
                                          InputText,
                                          index,
                                          "participantNameEn",
                                        );
                                      }
                                    }}
                                  />
                                </div>
                              ) : keyData.key === "age" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full whitespace-nowrap font-bold">
                                    {keyData.title}
                                  </div>
                                  <input
                                    type="text"
                                    className={mainTable.input}
                                    value={row.age}
                                    maxLength={100}
                                    placeholder="Age"
                                    onChange={(e) => {
                                      const InputText = e.target.value;
                                      if (/^\d{0,2}$/.test(InputText)) {
                                        handleInputChange(
                                          InputText,
                                          index,
                                          "age",
                                        );
                                        updateTableData(
                                          InputText,
                                          index,
                                          "age",
                                        );
                                      }
                                    }}
                                  />
                                </div>
                              ) : keyData.key === "gender" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full font-bold">
                                    {keyData.title}
                                  </div>
                                  <DropDown
                                    options={bindgenderRadioDD}
                                    placeholder="Select"
                                    name="gender"
                                    selectedOption={row.gender}
                                    controlFunc={(e) =>
                                      updateTableData(
                                        e.target.value,
                                        index,
                                        "gender",
                                      )
                                    }
                                  />
                                </div>
                              ) : keyData.key === "mobileNumber" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full font-bold">
                                    {keyData.title}
                                  </div>
                                  <input
                                    type="text"
                                    className={mainTable.input}
                                    value={row.mobileNumber}
                                    maxLength={11}
                                    onChange={(e) => {
                                      const InputText = e.target.value;
                                      if (/^[0-9]*$/.test(InputText)) {
                                        handleInputChange(
                                          InputText,
                                          index,
                                          "mobileNumber",
                                        );
                                        updateTableData(
                                          InputText,
                                          index,
                                          "mobileNumber",
                                        );
                                        if (isValidMobileNumber(InputText)) {
                                          setParticipantError("");
                                        } else {
                                          setParticipantError(
                                            "Invalid mobile number",
                                          );
                                        }
                                      }
                                      if (e.target.value == "") {
                                        setParticipantError("");
                                      }
                                    }}
                                  />
                                </div>
                              ) : keyData.key === "referralService" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full whitespace-nowrap font-bold">
                                    {keyData.title}
                                  </div>
                                  <DropDown
                                    options={bindreferelserviceDD}
                                    placeholder="Select"
                                    name="referralService"
                                    selectedOption={row.referralService}
                                    controlFunc={(e) =>
                                      updateTableData(
                                        e.target.value,
                                        index,
                                        "referralService",
                                      )
                                    }
                                  />
                                </div>
                              ) : keyData.key === "referredTo" ? (
                                <div className=" border p-1">
                                  <div className="flex items-center w-full whitespace-nowrap font-bold">
                                    {keyData.title}
                                  </div>
                                  <DropDown
                                    options={bindreferredtoDD}
                                    placeholder="Select"
                                    name="referredTo"
                                    selectedOption={row.referredTo}
                                    controlFunc={(e) =>
                                      updateTableData(
                                        e.target.value,
                                        index,
                                        "referredTo",
                                      )
                                    }
                                  />
                                </div>
                              ) : keyData.key === "fallowUpDate" ? (
                                <div className=" border p-1">
                                  <InputText
                                    inputType="date"
                                    content={row.fallowUpDate}
                                    controlFunc={(e) => {
                                      handleInputChange(
                                        e.target,
                                        index,
                                        "fallowUpDate",
                                      );
                                      updateTableData(
                                        e.target.value,
                                        index,
                                        "fallowUpDate",
                                      );
                                    }}
                                    min={new Date().toISOString().split("T")[0]}
                                  />
                                </div>
                              ) : (
                                <div className="flex border p-1">
                                  <div className="flex basis-1/2 font-bold">
                                    {keyData.title}
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      ))}
                  </div>
                </div>
                <div className="md:hidden">
                  {participantError && (
                    <div className="text-red-500">{participantError}</div>
                  )}
                </div>
                <div class="lg:col-span-5 sm:col-span-1">
                  <TextArea
                    inputType="text"
                    title="Description"
                    name="description"
                    rows={4}
                    tabIndex="0"
                    maxLength={500}
                    content={description}
                    placeholder="Description"
                    controlFunc={(e) => setDescription(e.target.value)}
                  />
                </div>
              </form>
              <Buttons
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                handleSubmit={handleSubmit}
                cancel={cancel}
                disabledBtn={submitBtnDisabled ? true : false}
              />
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={HandleGMMDetails}
      >
        <div className=" flex flex-col gap-3">
          <PopUpScreenTitle
            title="General / Mass Meeting (21+)"
            setpopUpOpen={handleClose}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
          />
          <GeneralMassMeetingPopup
            data={currentData}
            data1={currentData2}
            data2={currentData3}
            data3={currentData4}
            data4={currentData5}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
}

export default GeneralMassMeeting;
